import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { GlobalHelper } from '../utils/GlobalHelper';
import { ExtraPopup } from '../stores/ToolsStore';
import { CameraHelper } from '../utils/CameraHelper';

import pl = egr.wcf.pl;
import core = egr.wcf.core;

export abstract class ToolsActions {
    public static hideSmartExtra(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_SMART_EXTRA,
            value: null
        });
    }

    public static showSmartExtra(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_SMART_EXTRA,
            value: ExtraPopup.MENU
        });
    }

    public static showCameraSelection(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_SMART_EXTRA,
            value: ExtraPopup.CAMERA
        });
    }

    public static showFloorPlanMenu(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_SMART_EXTRA,
            value: ExtraPopup.FLOORPLAN
        });
    }

    public static setCamera(mode: core.view.CameraMode, view?: core.view.View): void {
        CameraHelper.setCameraMode(mode, view);
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_CAMERA,
            value: mode
        });
    }

    public static sendImage(value: string | null): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SEND_IMAGE,
            value: value
        });
    }

    public static endRectangleSelect(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_RECTANGLESELECT,
            value: false
        });
    }

    public static startRectangleSelect(): void {
        GlobalHelper.coreApp.tools.startDefaultTool();
        (GlobalHelper.coreApp.tools.defaultTool as pl.tool.Default).startRectangleSelect();
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_RECTANGLESELECT,
            value: true
        });
    }

    public static setMultiSelect = (value: boolean) => {
        (GlobalHelper.coreApp.tools.defaultTool as pl.tool.Default).multiSelectMode = value;
        GlobalHelper.coreApp.tools.startDefaultTool();
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_MULTISELECT,
            value: value
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/ToolsActions.ts